module.exports = __webpack_public_path__ + "img/ec4810f5b49524ac745ea2ddb4ba06e2.png";